import { useEffect, useState } from "react";
import { popup, useRawLaunchParams } from "@tma.js/sdk-react";

export function useTelegramChatId() {
  const [chatId, setChatId] = useState<string | null>(null);
  const rawInitData = useRawLaunchParams();

  useEffect(() => {
    const startParam = new URLSearchParams(rawInitData).get(
      "tgWebAppStartParam",
    );
    const chatId = startParam?.startsWith("gid_") ? startParam.slice(4) : null;
    if (!chatId) {
      popup.show({ message: "Telegram chat id not available." });
      return;
    }
    setChatId(chatId);
  }, [rawInitData]);

  return chatId;
}
